import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="state-selector"
export default class extends Controller {
  static targets = ["country", "us", "canada", "mexico"];

  connect() {
    this.updateVisibility();
  }

  change() {
    this.updateVisibility();
  }

  updateVisibility() {
    const selected = this.countryTarget.value;

    if (selected === "United States") {
      this.show(this.usTarget);
      this.hide(this.canadaTarget);
      this.hide(this.mexicoTarget);
    } else if (selected === "Canada") {
      this.hide(this.usTarget);
      this.show(this.canadaTarget);
      this.hide(this.mexicoTarget);
    } else if (selected === "Mexico") {
      this.hide(this.usTarget);
      this.hide(this.canadaTarget);
      this.show(this.mexicoTarget);
    } else {
      this.hide(this.usTarget);
      this.hide(this.canadaTarget);
      this.hide(this.mexicoTarget);
    }
  }

  show(element) {
    element.classList.remove("hidden");
    const select = element.querySelector("select");
    if (select) {
      select.disabled = false;
      select.required = true;
    }
  }

  hide(element) {
    element.classList.add("hidden");
    const select = element.querySelector("select");
    if (select) {
      select.disabled = true;
      select.required = false;
    }
  }
}
